import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { User, Locale } from '../../_models';
import { UserService, AuthenticationService } from '../../_services';
import { UntypedFormBuilder, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { SnackbarService } from '../../_service/message-service';
import { VendorService } from 'src/app/_services/vendor.services';
import { APP_URL } from '../../util/constants';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MenuRouteID, NavItem } from './menu-item/nav-item';
import { startWith } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree'
import { MatMenuTrigger } from '@angular/material/menu';
import { Permission } from 'src/app/util/enums/permission.enum';
import { Role } from 'src/app/util/enums/role.enum';
import { RouteConstants } from 'src/app/util/route.constants';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';
import { NotificationService } from 'src/app/_services/notification.service.v2';
import { brandName } from 'src/app/theme/brand.name.enum';

declare var $: any;

@Component({
  selector: 'telio-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewChecked {
  currentUser: User;
  userDetails: any = {};
  /** Logo size override on rudvedev / rudved-ev hosts (e.g. rudved-ev.cms.telioev.com) */
  isRudvedevHost = typeof location !== 'undefined' && /rudved[-]?ev/i.test(location.hostname);
  readonly defaultLogo = 'assets/images/telioEv/telioevlogonew.png';
  forgotform: UntypedFormGroup;
  loginemail;
  infonotificationCount = 0;
  count = 0;
  adminrole: any;
  logoutEndpoint: string;
  tempPasswordValue;
  role;
  checkemail;
  showProfile = false;
  readonly subscriptions = new Subscription();
  oldPassword = false;
  newPassword = false;
  confirmPassword = false;
  enableLangPopup = false;
  enableCountryPopup = false;
  enableFlag = true;
  userNameChar = '';
  lang: string;
  selectedLang = {};
  timeout;
  languages = [];
  countries = [];
  countryselected = true;
  country: any;
  language: any;
  navItems: NavItem[] = [];
  userId;
  subs: Subscription = new Subscription;
  langList: Locale[] = [{
    id: 1,
    name: 'en_US',
    description: 'English – United State',
    language: 'en',
    country: 'US',
    decChar: '',
    amtConversion: '',
    dateConversion: ''
  }];
  sideBar = false;

  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    this.showProfile = false;
    this.enableLangPopup = false;
    this.enableCountryPopup = false;
    this.sideBar = false;
  }

  @ViewChild('updatePwd', { static: false }) updatePwd: TemplateRef<any>;
  isExpanded = false;
  treeControl = new NestedTreeControl<FoodNodeFlat>(node => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNodeFlat>();

  @ViewChild('tree', { static: false }) tree: any;
  @ViewChild('menuTriggerRef', { static: false, read: MatMenuTrigger }) menuTrigger: MatMenuTrigger;


  constructor(
    private router: Router,
    public userService: UserService,
    private authenticationService: AuthenticationService,
    private formBuilder: UntypedFormBuilder,
    private toastr: SnackbarService,
    private vendorservice: VendorService,
    readonly translate: TranslateService,
    public dialog: MatDialog,
    readonly userInfoService: UserInfoService,
    readonly cd: ChangeDetectorRef,
    private notificationService:NotificationService,
    readonly breadcrumbService: BreadcrumbService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.setDefaultLang();
  }

  /** Tenant logo from userInfo (available before first paint via AppResolver). */
  get logoSrc(): string {
    const details = this.userInfoService.userDetails;
    if (details?.tenantID && details.tenantID.toLowerCase() !== brandName.telioev && details.logoUrl) {
      return details.logoUrl;
    }
    return this.defaultLogo;
  }

  ngOnInit() {
    this.userDetails = this.userInfoService.userDetails;
    this.userNameChar = !!this.userDetails['username'] ? this.userDetails['username'].charAt(0).toUpperCase() : '';
    this.adminrole = this.userInfoService.isAdminGroup();
    this.loginemail = this.userDetails.email;
    this.userId = this.userDetails.userId
    this.getLanguages();
    this.getcountries();
    this.logoutEndpoint = APP_URL + '/logout';
    if (!this.adminrole)
      this.getNotificationcount()
    const passwordRegEX: RegExp = /^((?=.*\d)(?=.*[a-z])(?=.*[\W]).{8,15})$/;
    this.forgotform = this.formBuilder.group({
      oldpassword: ['', Validators.required],
      newpassword: ['', Validators.compose([
        Validators.required,
        Validators.pattern(passwordRegEX)
      ])],
      renewpassword: ['', Validators.compose([
        Validators.required,
        Validators.pattern(passwordRegEX)
      ])]
    })
    this.getRootMenuList(this.userInfoService.userDetails['prefLanguage'] ? this.userInfoService.userDetails['prefLanguage'] : 'en');
  }

  ngAfterViewChecked() {
    this.cd.detectChanges();
  }

  // getRootMenuList(lang? : string) {
  //   const tenantID = this.userInfoService.userDetails.tenantID || 'TELIOEV';
  //   this.userInfoService.getMenuList(tenantID, lang).subscribe(res => {
  //     this.userInfoService.menuList = res;
  //     localStorage.setItem('menuList', JSON.stringify(res));
  //     let resp = res.filter(r => r.type == 'dashboard')
  //     this.dataSource.data = this.treeConstruct(resp);
  //     this.treeControl.dataNodes = this.dataSource.data;
  //     !!this.treeControl.dataNodes && this.treeControl.dataNodes.forEach((res: any, index: number) => {
  //       this.treeControl.collapse(this.treeControl.dataNodes[index])
  //     });
  //     this.isExpanded = false;
  //   })
  // }

  getRootMenuList(lang?: string) {
    const tenantID = this.userInfoService.userDetails.tenantID || 'TELIOEV';
    this.userInfoService.getMenuList(tenantID, lang).subscribe(res => {
      const index = res.findIndex(item => item.id === MenuRouteID.ROAMING_ANALYTICS);
      if (index !== -1) {
        res.splice(index, 1);
      }
      this.userInfoService.menuList = res;
      localStorage.setItem('menuList', JSON.stringify(res));
      let resp = res.filter(r => r.type == 'dashboard')
      this.dataSource.data = this.treeConstruct(resp);
      this.treeControl.dataNodes = this.dataSource.data;
      !!this.treeControl.dataNodes && this.treeControl.dataNodes.forEach((res: any, index: number) => {
        this.treeControl.collapse(this.treeControl.dataNodes[index])
      });
      this.isExpanded = false;
    })
  }

  getNotificationcount() {
    this.subs = Observable.interval(5000).pipe(startWith(0)).subscribe((val: any) => {
      {
        var temp = this.authenticationService.getEmail();
        this.subscriptions.add(this.notificationService.getNotificationcount(temp).subscribe(
          (data: any) => {
            let res= data.data;
            this.count = !!res ? +(res) : 0;
            this.vendorservice.notifyCount$.next(this.count);
          }, err => {
            this.count = 0;
            this.vendorservice.notifyCount$.next(this.count);
          }));

        this.subscriptions.add(this.notificationService.getInfoNotificationCount(this.userId).subscribe(
          (data: any) => {
            let res= data.data
            this.infonotificationCount = !!res ? (res) : 0;
            this.vendorservice.infoUpdateCount$.next(this.infonotificationCount);
          }, err => {
            this.infonotificationCount = 0;
            this.vendorservice.infoUpdateCount$.next(this.infonotificationCount);
          }));
      }
    });
  }

  get isAdmin() {
    return this.userInfoService.groups && this.userInfoService.isAdminGroup();
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/']);
  }

  changepasswordopen() {
    this.oldPassword = false;
    this.newPassword = false;
    this.confirmPassword = false;
    this.forgotform.reset();
    let dialogRef = this.dialog.open(this.updatePwd, {
      width: '60vw',
      height: '72vh',
    }).afterClosed()
  }

  closeforgotpwd(formDirective: FormGroupDirective): void {
    this.oldPassword = false;
    this.newPassword = false;
    this.confirmPassword = false;
    formDirective.resetForm();
    this.forgotform.reset();
    this.dialog.closeAll();
  }

  clearForm() {
    (<HTMLFormElement>document.getElementById("forgot")).reset();
  }

  submitpasswordform() {
    if (this.forgotform.value.oldpassword == this.forgotform.value.newpassword) {
      this.toastr.error(this.translate.instant('header.passwordError1'))
      this.dialog.closeAll()
      return;
    }
    if (this.forgotform.invalid) {
      this.dialog.closeAll()
      return;
    }
    else {
      this.checkemail = this.loginemail;
      this.role = (this.checkemail == "superadmin@telioev.com") ? Role.SUPERADMIN : Role.CMS;
      if (this.forgotform.value.newpassword != this.forgotform.value.renewpassword) {
        this.toastr.error(this.translate.instant('header.passwordError2'))
        this.dialog.closeAll()
        return
      }

      this.subscriptions.add(this.userService.changeOldPassword(this.forgotform.value.oldpassword, this.loginemail, this.forgotform.value.newpassword, this.role).subscribe((resp: any) => {
        !!resp ? (this.toastr.success(resp.status_message), this.logout()) : this.toastr.error(this.translate.instant('header.incorrectPassword'));
        this.dialog.closeAll()
      }, error => {
        this.toastr.error(this.translate.instant('responseFailed'));
      }));
    }
  }

  setPreferred(type) {
    type !== 'country' ? this.setPreferredLang() : this.setPreferredCountry();
  }

  async setPreferredLang() {
    try {
      const res = await this.userService.updatePreferredLang(this.userDetails['userId'], localStorage.getItem('lang')).toPromise();
      this.toastr.success(res.status_message, 'success-mssg');
      await this.userInfoService.getUserInfo();
      await this.getRootMenuList(this.userInfoService.userDetails['prefLanguage'] ? this.userInfoService.userDetails['prefLanguage'] : 'en');
    } catch (err) {
      this.toastr.error(err.message, 'error-mssg', 300);
    }
  }

  setPreferredCountry() {
    this.subscriptions.add(this.userService.updatePreferredCountry(this.userDetails['userId'], localStorage.getItem('country')).subscribe(res => {
      this.toastr.success(res.status_message, 'success-mssg');
      this.userInfoService.getUserInfo();
    }, err => {
      this.toastr.error(err.message, 'error-mssg', 300);
    }));
  }

  getLanguages() {
    this.subscriptions.add(this.userService.getLocales().subscribe((res: Locale[]) => {
      if (!!res) {
        const langs = res.map(res => res.language);
        this.translate.addLangs(langs);
        this.langList = res;
        this.setDefaultLang(this.userDetails['prefLanguage']);
      } else {
        this.setDefaultLang();
      }
    }, err => {
      this.setDefaultLang();
    }));
  }

  setDefaultLang(setLang?: any) {
    !setLang ? this.switchLang(this.langList[0]) : this.langList.map(res => (res.language == setLang) && this.switchLang(res));
  }

  switchLang(data: any) {
    this.selectedLang = data;
    this.setLangLocalStorage(data.language);
    this.translate.use(data.language);
    this.getRootMenuList(data.language);
  }

  setLangLocalStorage(lang: string) {
    localStorage.setItem('lang', lang);
    document.documentElement.lang = lang;
  }

  countryselect(data) {
    this.country = data;
    this.authenticationService.setLocalInfo = data;
    this.authenticationService.setLocalCurrency = data.currency_symbol
    localStorage.setItem('country', data.country);
  }

  getcountries() {
    this.subscriptions.add(this.userService.getLanguagesbycountry().subscribe((res: any) => {
      if (!!res) {
        this.countries = res;
        if (!this.userDetails['prefCountry']) {
          this.countryselect(res[0]);
        } else {
          this.countryselect(this.countries.filter(obj => obj.country === this.userDetails['prefCountry'])[0]);
        }
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions && this.subscriptions.unsubscribe();
    this.subs && this.subs.unsubscribe();
  }

  myprofile() {
    this.myProfileCall()
    // let availableTabs = [
    //   { id: MenuRouteID.TABS.OPERATOR_DETAILS, enable: false },
    //   { id: MenuRouteID.TABS.STATION_DETAILS, enable: false }
    // ];
    // availableTabs = this.userInfoService.getPermittedTabs(MenuRouteID.OPERATORS, availableTabs);
    // let tabExists = availableTabs.filter(res => res.enable);
    // !tabExists || tabExists.length == 0 ? this.toastr.info(this.translate.instant('unAuthorized')) : this.myProfileCall()
  }
  
  myProfileCall() {
    this.vendorservice.getvendorinfobyvendorid(this.userDetails.email, this.userInfoService.groups[0]).subscribe(res => {
      if (res.status_code != "500") {
        let vendorlist = res;
        this.goToMyProfile(vendorlist);
      } else {
        this.toastr.error(this.translate.instant('responseFailed'));
      }
    }, err => {
      this.toastr.error(this.translate.instant('responseFailed'));
    })
  }
  goToMyProfile(vendor) {
    this.userService.getLanguagesbycountry().subscribe((res: any) => {
      if (!!res) {
        let filterCountries = res.map((resp: any) => resp.country.toLowerCase());

        let selectedvendor = JSON.stringify(vendor);
        let objToSend: NavigationExtras = {
          queryParams: {
            "station": selectedvendor,
            "vendorId": this.loginemail,
            "editvendor": true,
            "routedName": "home",
            "groupType": vendor.group_type,
            listedCountries: filterCountries,
            "isMyProfile": true,
          },
          skipLocationChange: true
        };
        if(this.userInfoService.isCPOSubCPOGroup()){
          this.router.navigate(["/dashboard/charge-point-operators", { routeID: MenuRouteID.OPERATORS }], objToSend);
          this.breadcrumbService.emitBreadCrumbs(RouteConstants.MY_PROFILE);
        }
        else{
          this.router.navigate(["/dashboard/operators/create", { routeID: MenuRouteID.CMS_USERS }], objToSend);
          this.breadcrumbService.emitBreadCrumbs(RouteConstants.MY_PROFILE);
        }
      }
    })
  }

  hasChild = (_: number, node: FoodNodeFlat) => !!node.children && node.children.length > 0;

  treeConstruct(treeData: FoodNodeFlat[]) {
    let constructedTree: any = [];
    for (let i of treeData) {
      this.constructTree(constructedTree, i, false);
    }
    return constructedTree;
  }

  constructTree(constructedTree: any, treeObj: any, assigned: any) {
    switch (true) {
      case (treeObj.parent_id == 0):
        treeObj.children = [];
        constructedTree.push(treeObj);
        return true;

      case (treeObj.parent_id == constructedTree.id):
        treeObj.children = [];
        constructedTree.children.push(treeObj);
        return true;

      default:
        (!!constructedTree.children) ? this.loopConstruct(constructedTree.children, treeObj, assigned) :
          this.loopConstruct(constructedTree, treeObj, assigned);
        return false;
    }
  }

  loopConstruct(listValue: any, treeObj: any, assigned: any) {
    return !!listValue && Array.from(listValue).forEach((ele: any, index: number = 0) => {
      !assigned && (assigned = this.constructTree(listValue[index], treeObj, assigned))
    })
  }

  getImageUrl(img: any) {
    return `assets/images/icons/menu/` + img;
  }

  isActive(item) {
    return item.path == this.router.url.split(';')[0];
  }

  routerLink(screen: string) {
    let path: any = [];
    switch (screen) {
      case 'info':
        path = ['/dashboard/info', { routeID: MenuRouteID.INFO_UPDATES }];
        break;
      case 'alerts': path = ['/dashboard/alerts', { routeID: MenuRouteID.ALERTS }];
        break;
      case 'faq': path = ['/dashboard/faq', { routeID: MenuRouteID.PROFILES.FAQ }];
        break;
    }
    this.router.navigate(path);
  }

  checkPermission(menu: string) {
    switch (menu) {
      case 'profile':
        return this.userInfoService.filterPermission(MenuRouteID.OPERATORS, Permission.READ)
      case 'faq':
        return this.userInfoService.filterPermission(MenuRouteID.PROFILES.FAQ, Permission.READ)
      case 'choosePreference':
        if (this.userInfoService.filterPermission(MenuRouteID.PROFILES.UPDATE_LANGUAGE, Permission.UPDATE) || this.userInfoService.filterPermission(MenuRouteID.PROFILES.UPDATE_COUNTRY, Permission.UPDATE)) {
          return this.userInfoService.filterPermission(MenuRouteID.PROFILES.CHOOSE_PREFERENCES, Permission.UPDATE)
        }
      case 'updateLanguage':
        return this.userInfoService.filterPermission(MenuRouteID.PROFILES.UPDATE_LANGUAGE, Permission.UPDATE)
      case 'updateCountry':
        return this.userInfoService.filterPermission(MenuRouteID.PROFILES.UPDATE_COUNTRY, Permission.UPDATE)
      default:
        break;
    }
  }
}


interface FoodNodeFlat {
  name: string;
  id: number;
  parent_id: any;
  children?: FoodNodeFlat[];
}
